import { RemoveRedEye } from "@mui/icons-material";
import { Button } from "components/Button/Button";
import IconButton from "components/Button/IconButton";
import Link from "components/Button/Link";
import { Input } from "components/Form";
import NotFound from "components/not-found/NotFound";
import useFullPageLoader from "hooks/useFullPageLoader";
import useMuiButtonLoader from "hooks/useMuiButtonLoader";
import React, { useEffect, useState } from "react";
import { Pagination } from "react-bootstrap";
import toast from "react-hot-toast";
import DeleteIcon from "@mui/icons-material/Delete";
import AutoAwesomeMotionIcon from "@mui/icons-material/AutoAwesomeMotion";
import EditIcon from "@mui/icons-material/Edit";
import {
  createPostalContentFolder,
  deleteFolderFromPostalDocs,
  getPostalFolderContent,
  getPostalFolders,
  renameFile,
  renameFolder,
  uploadFilesInPostalDocument,
} from "services/foldermanagement";
import { dateFormat, rawToHtmlConverter } from "utils";
import ModalBox from "components/modal/ModalBox";
import LaunchIcon from "@mui/icons-material/Launch";
import { read } from "xlsx";
import { encryptData } from "config/config";
import useCookie from "hooks/useCookie";

export default function FolderList() {
  const [flag, setFlag] = useState(false);
  const { cookies } = useCookie();

  // ***************************************************** These is for first record **********************************************************
  const [search1, setSearch1] = useState("");
  const [record1, setRecord1] = useState([]);
  const [total1, setTotal1] = useState(0);
  const [activePage1, setActivePage1] = useState(1);
  const [limit1, setLimit1] = useState(10);
  const [deleteModal1, setDeleteModal1] = useState(false);
  const [addModal1, setAddModal1] = useState(false);
  const [editModal1, setEditModal1] = useState(false);
  const [uploadModal1, setUploadModal1] = useState(false);
  const [data1, setData1] = useState({});
  const [selectedId1, setSelectedId1] = useState("");

  const [submitButtonElement1, setSubmitLoading1] = useMuiButtonLoader();
  const [loader1, showLoader1, hideLoader1] = useFullPageLoader();

  // ***************************** Fetch Records *******************************
  const handleRecords1 = async () => {
    showLoader1();
    setSubmitLoading1(true);
    try {
      const finalData = {
        search: search1,
        // page: activePage,
      };
      const res = await getPostalFolders(finalData);

      if (res.code === 200) {
        setRecord1(res.data || []);
        // setTotal(res.data.exceptionalAccess.count || 0);
      } else {
        toast.error(res.message);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
    }
    setSubmitLoading1(false);
    hideLoader1();
  };

  useEffect(() => {
    // if (search) {
    localStorage.removeItem("folder");
    handleRecords1();
    // }
  }, [activePage1, search1]);

  // ***************************** Handle Add Folder *******************************
  const handleAdd1 = async () => {
    showLoader1();
    setSubmitLoading1(true);
    try {
      const finalData = {
        folderName: data1.file,
      };
      const res = await createPostalContentFolder(finalData);

      if (res.code === 200) {
        setAddModal1(false);
        handleRecords1();
        setData1({});
        toast.success(res.message);
      } else {
        setAddModal1(false);
        handleRecords1();
        setData1({});
        toast.error(res.message);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
    }
    setSubmitLoading1(false);
    hideLoader1();
  };

  // ***************************** Handle Update Folder *******************************
  const handleUpdate1 = async () => {
    showLoader1();
    setSubmitLoading1(true);
    try {
      const finalData = {
        platformType: "chrome",
        oldFolderName: data1.oldFile,
        newFolderName: data1.file,
      };
      const res = await renameFolder(finalData);

      if (res.code === 200) {
        setEditModal1(false);
        handleRecords1();
        setData1({});
        toast.success(res.message);
      } else if (res.message === "This copy request is illegal because it is trying to copy an object to itself without changing the object's metadata, storage class, website redirect location or encryption attributes.") {
        toast.error("New folder name must be different from the old folder name");
      }
      else {
        setEditModal1(false);
        handleRecords1();
        setData1({});
        toast.error(res.message);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
    }
    setSubmitLoading1(false);
    hideLoader1();
  };

  // ***************************** Handle Delete Folder *******************************
  const handleDelete1 = async () => {
    showLoader1();
    setSubmitLoading1(true);
    try {
      const finalData = {
        search: search1,
        page: activePage1,
      };
      // const res = await getStudentExceptionalAccessListt(finalData);

      // if (res.code === 200) {
      //   setRecord(res.data.exceptionalAccess.rows || []);
      //   setTotal(res.data.exceptionalAccess.count || 0);
      // } else {
      //   toast.error(res.message);
      // }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
    }
    setSubmitLoading1(false);
    hideLoader1();
  };

  // ***************************** Handle Upload Document *******************************
  const handleUpload1 = async () => {
    showLoader1();
    setSubmitLoading1(true);
    try {
      const formData = new FormData();
      formData.append("docfile", data1.document);
      formData.append(
        "reqData",
        encryptData({
          access_token: cookies,
          filename: data1.document.name,
        })
      );
      // console.log("upload:",formData,data1.document.name);
      const res = await uploadFilesInPostalDocument(formData);

      if (res.code === 200) {
        setUploadModal1(false);
        handleRecords1();
        setData1({});
        toast.success(res.message);
      } else {
        setUploadModal1(false);
        handleRecords1();
        setData1({});
        toast.error(res.message);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
    }
    setSubmitLoading1(false);
    hideLoader1();
  };

  // *************************************** Try idea 2 *************************************************
  // *************************************** Try idea 2 *************************************************
  const [currentPath, setCurrentPath] = useState([]);
  const [filePath, setFilePath] = useState("");

  // const convertPath = (path) => {
  //   return path.replace(/\//g, ">");
  // };
  // const convertPath = (path) => {
  //   return path.join(">");
  // };

  // const realignPath = (i) => {
  //   let arr = currentPath;
  //   // if(i==0){
  //   //   setCurrentPath([])
  //   //   setFilePath("")
  //   // }else{
  //   currentPath.map((data, j) => {
  //     if (i <= j) {
  //       arr.pop();
  //     }
  //   });
  //   setCurrentPath(arr);
  //   // }
  // };

  useEffect(() => {
    if (currentPath.length > 0 && filePath) {
      setFlag(true);
    } else {
      setFlag(false);
    }
  }, [filePath, currentPath]);

  // State to store the array
  const [newPath, setNewPath] = useState(currentPath);

  // Function to handle the click event
  const handleClick = (index) => {
    if (index == 0) {
      setCurrentPath([]);
      setFilePath("");
      setNewPath([]);
    } else {
      const updatedArray = newPath.slice(0, index + 1);
      setNewPath(updatedArray);
      setCurrentPath(updatedArray);
      setFilePath(updatedArray.join("/") + "/");
    }
  };

  // ***************************************************** These is for second record **********************************************************
  const [search2, setSearch2] = useState("");
  const [record2, setRecord2] = useState([]);
  const [record3, setRecord3] = useState([]);
  const [total2, setTotal2] = useState(0);
  const [activePage2, setActivePage2] = useState(1);
  const [limit2, setLimit2] = useState(10);
  const [deleteModal2, setDeleteModal2] = useState(false);
  const [deleteModal3, setDeleteModal3] = useState(false);
  const [addModal2, setAddModal2] = useState(false);
  const [editModal2, setEditModal2] = useState(false);
  const [editModal3, setEditModal3] = useState(false);
  const [uploadModal2, setUploadModal2] = useState(false);
  const [data2, setData2] = useState({});
  const [selectedId2, setSelectedId2] = useState("");
  const [errorField2, setErrorField2] = useState({});

  const [submitButtonElement2, setSubmitLoading2] = useMuiButtonLoader();
  const [loader2, showLoader2, hideLoader2] = useFullPageLoader();

  // ***************************** Fetch Records *******************************
  const handleRecords2 = async () => {
    showLoader2();
    //setSubmitLoading2(true);
    try {
      const res = await getPostalFolderContent({
        search: search2,
        page: activePage2,
        platformType: "chrome",
        folderName: filePath,
      });

      if (res.code === 200) {
        setRecord2(res.data.files || []);
        console.table(res.data.subfolders);
        setRecord3(res.data.subfolders || []);
        // setTotal(res.data.exceptionalAccess.count || 0);
      } else {
        toast.error(res.message);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
    }
    //setSubmitLoading2(false);
    hideLoader2();
  };

  useEffect(() => {
    // if (search) {

    if (currentPath.length > 0 && filePath) {
      handleRecords2();
    }
    // }
  }, [activePage2, search2, filePath, currentPath]);

  // ***************************** Handle Add Folder *******************************
  const handleAdd2Validation = () => {
    let isError = false;
    const newErrorField = {};
    if (!data2.file) {
      newErrorField.file = "Please Enter Folder Name";
      isError = true;
    } else {
      newErrorField.file = "";
    }

    setErrorField2(newErrorField);
    return !isError;
  };

  const handleAdd2 = async () => {
    showLoader2();
    setSubmitLoading2(true);

    try {
      if (handleAdd2Validation()) {
        const finalData = {
          folderName: filePath + data2.file,
        };
        const res = await createPostalContentFolder(finalData);

        if (res.code === 200) {
          setAddModal2(false);
          handleRecords2();
          setData2({});
          setErrorField2({});
          toast.success(res.message);
        } else {
          setAddModal2(false);
          handleRecords2();
          setData2({});
          setErrorField2({});
          toast.error(res.message);
        }
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
    }
    setSubmitLoading2(false);
    hideLoader2();
  };

  // ***************************** Handle Update Folder *******************************
  const handleUpdate2Validation = () => {
    let isError = false;
    const newErrorField = {};
    if (!data2.file) {
      newErrorField.file = "Please Enter Folder Name";
      isError = true;
    } else {
      newErrorField.file = "";
    }

    setErrorField2(newErrorField);
    return !isError;
  };

  const handleUpdate2 = async () => {
    showLoader2();
    setSubmitLoading2(true);
    try {
      if (handleUpdate2Validation()) {
        const finalData = {
          platformType: "chrome",
          oldFolderName: filePath + data2.oldFile,
          newFolderName: filePath + data2.file,
        };
        const res = await renameFolder(finalData);

        if (res.code === 200) {
          setEditModal2(false);
          handleRecords2();
          setData2({});
          toast.success(res.message);
        }else if (res.message === "This copy request is illegal because it is trying to copy an object to itself without changing the object's metadata, storage class, website redirect location or encryption attributes.") {
          toast.error("New folder name must be different from the old folder name");
        } else {
          setEditModal2(false);
          handleRecords2();
          setData2({});
          toast.error(res.message);
        }
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
    }
    setSubmitLoading2(false);
    hideLoader2();
  };

  const handleUpdate3Validation = () => {
    let isError = false;
    const newErrorField = {};
    if (!data2.fileName) {
      newErrorField.fileName = "Please Enter File Name";
      isError = true;
    } else {
      newErrorField.fileName = "";
    }

    setErrorField2(newErrorField);
    return !isError;
  };

  const handleUpdate3 = async () => {
    showLoader2();
    setSubmitLoading2(true);
    try {
      if (handleUpdate3Validation()) {
        const finalData = {
          platformType: "chrome",
          oldFileName: filePath + data2.oldFileName,
          newFileName: filePath + data2.fileName,
        };
        // console.log(finalData)
        const res = await renameFile(finalData);

        if (res.code === 200) {
          setEditModal3(false);
          handleRecords2();
          setData2({});
          toast.success(res.message);
        } else {
          setEditModal3(false);
          handleRecords2();
          setData2({});
          toast.error(res.message);
        }
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
    }
    setSubmitLoading2(false);
    hideLoader2();
  };

  // ***************************** Handle Delete File *******************************
  const handleDelete2 = async () => {
    showLoader2();
    setSubmitLoading2(true);
    try {
      const finalData = {
        fileName: filePath + data2.fileName,
      };
      // console.log(finalData)
      const res = await deleteFolderFromPostalDocs(finalData);

      if (res.code === 200) {
        setDeleteModal2(false);
        handleRecords2();
        setData2({});
        toast.success(res.message);
      } else {
        setDeleteModal2(false);
        handleRecords2();
        setData2({});
        toast.error(res.message);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
    }
    setSubmitLoading2(false);
    hideLoader2();
  };

  // ***************************** Handle Delete Folder *******************************
  const handleDelete3 = async () => {
    showLoader2();
    setSubmitLoading2(true);
    try {
      const finalData = {
        fileName: filePath + data2.folderName,
      };
      // console.log(finalData)
      const res = await deleteFolderFromPostalDocs(finalData);

      if (res.code === 200) {
        setDeleteModal3(false);
        handleRecords2();
        setData2({});
        toast.success(res.message);
      } else {
        setDeleteModal3(false);
        handleRecords2();
        setData2({});
        toast.error(res.message);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
    }
    setSubmitLoading2(false);
    hideLoader2();
  };

  // ***************************** Handle Upload Document *******************************
  const handleUpload2Validation = () => {
    let isError = false;
    const newErrorField = {};
    // console.log(data2.file);
    if (!data2.document?.name) {
      newErrorField.document = "Please Select File";
      isError = true;
    } else {
      newErrorField.document = "";
    }

    setErrorField2(newErrorField);
    return !isError;
  };

  const handleUpload2 = async () => {
    showLoader2();
    setSubmitLoading2(true);
    try {
      if (handleUpload2Validation()) {
        const formData = new FormData();
        const newFilePath = filePath.slice(0, -1);
        formData.append("docfile", data2.document);
        formData.append(
          "reqData",
          encryptData({
            access_token: cookies,
            filename: newFilePath,
          })
        );
        // console.log("new", newFilePath);
        // console.log("upload:",formData,data1.document.name);
        const res = await uploadFilesInPostalDocument(formData);

        if (res.code === 200) {
          setUploadModal2(false);
          handleRecords2();
          setData2({});
          toast.success(res.message);
        } else {
          setUploadModal2(false);
          handleRecords2();
          setData2({});
          toast.error(res.message);
        }
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
    }
    setSubmitLoading2(false);
    hideLoader2();
  };

  useEffect(() => {
    setNewPath(currentPath);
  }, [currentPath]);
  // console.log("x", currentPath);
  // console.log(filePath);

  // console.log(record3);

  // **************************************** Here disabled key for file input ***********************************************
  const [isFileInputFocused, setIsFileInputFocused] = useState(false);

  // Handler to disable keypress
  const handleKeyPress = (e) => {
    if (isFileInputFocused) {
      e.preventDefault(); // Disable key press
    }
  };

  // Add keypress listener on component mount
  useEffect(() => {
    document.addEventListener("keydown", handleKeyPress);

    // Cleanup event listener when component unmounts
    return () => {
      document.removeEventListener("keydown", handleKeyPress);
    };
  }, [isFileInputFocused]);

  return (
    <>
      <div className="">
        <div className="WrapperBox">
          <div className="Small-Wrapper">
            <div className="search_wrap">
              <div className="search_wrap">
                {!flag ? (
                  <div className="SearchBox ">
                    <div style={{ marginRight: "10px" }}>
                      {/* <Input
                      className={"form-control"}
                      placeholder="Search Here"
                      value={search1}
                      onChange={({ target }) => setSearch1(target.value)}
                      type="text"
                    /> */}
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      {/* <Button
                        style={{ marginRight: "10px" }}
                        onClick={() => {
                          setUploadModal1(true);
                        }}
                      >
                        Upload Document
                      </Button> */}
                      {/* <Button
                        style={{ marginRight: "10px" }}
                        onClick={() => {
                          setAddModal1(true);
                        }}
                      >
                        Create Folder
                      </Button> */}
                    </div>
                  </div>
                ) : (
                  <div className="SearchBox ">
                    {/* <div style={{ marginRight: "10px" }}>
                <Input
                  className={"form-control"}
                  placeholder="Search Here"
                  value={search}
                  onChange={({ target }) => setSearch(target.value)}
                  type="text"
                />
              </div> */}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <Button
                        style={{ marginRight: "10px" }}
                        onClick={() => {
                          setUploadModal2(true);
                        }}
                      >
                        Upload Document
                      </Button>
                      <Button
                        style={{ marginRight: "10px" }}
                        onClick={() => {
                          setAddModal2(true);
                        }}
                      >
                        Create Folder
                      </Button>
                    </div>
                  </div>
                )}
              </div>
              {!flag ? (
                <h4 className="Title">Documents</h4>
              ) : (
                <h4 className="Title">
                  <Link
                    // to={-1}
                    onClick={() => {
                      let arr = currentPath;
                      if (currentPath.length == 2) {
                        setCurrentPath([]);
                        arr = [];
                        setFilePath("");
                      } else {
                        // currentPath.pop();
                        arr.pop();
                        setFilePath(arr.join("/") + "/");
                      }
                    }}
                  >
                    <i className="fa fa-arrow-left"></i>
                  </Link>
                  {currentPath[currentPath.length - 1]} Documents
                </h4>
              )}
            </div>

            {/* <hr className="border border-danger" /> */}

            {/* // *************************************** Try idea 2 ************************************************* */}
            <div className="m-4 mt-1">
              {newPath.length > 0 &&
                newPath.map((data, i) => (
                  <>
                    {i == currentPath.length - 1 ? (
                      <>{data}</>
                    ) : (
                      <>
                        <Link
                          onClick={() => {
                            handleClick(i);
                          }}
                          style={{
                            textDecoration: "none",
                            color: "#0d6efd",
                          }}
                        >
                          {data}
                        </Link>
                        {" > "}
                      </>
                    )}
                  </>
                ))}
              <div></div>
            </div>
            {/* </div>
        <div className="WrapperBox"> */}
            {!flag ? (
              <>
                <div className="search_wrap">
                  <div className="search_wrap">
                    <div className="SearchBox ">
                      <div style={{ marginRight: "10px" }}>
                        {/* <Input
                      className={"form-control"}
                      placeholder="Search Here"
                      value={search1}
                      onChange={({ target }) => setSearch1(target.value)}
                      type="text"
                      /> */}
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        {/* <Button
                        style={{ marginRight: "10px" }}
                        onClick={() => {
                          setAddModal1(true);
                        }}
                      >
                        Create Folder
                      </Button> */}
                      </div>
                    </div>
                  </div>
                </div>
                {/* <hr className="border border-danger" /> */}
                {loader1}
                <div className="TableList overflow-auto table-responsive p-0">
                  <table className="position-relative">
                    <thead>
                      <tr>
                        <th
                          style={{
                            wordWrap: "break-word",
                            whiteSpace: "normal",
                            width: "100px",
                          }}
                        >
                          S.No
                        </th>
                        <th>Name</th>
                        <th>Type</th>
                        <th>Added On</th>
                        <th>Size</th>
                        {/* <th
                          style={{
                            wordWrap: "break-word",
                            whiteSpace: "normal",
                            width: "100px",
                            textAlign: "center",
                          }}
                        >
                          View Files
                        </th> */}
                        {/* <th
                          style={{
                            wordWrap: "break-word",
                            whiteSpace: "normal",
                            width: "100px",
                          }}
                        >
                          Actions
                        </th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {record1 && record1.length > 0 ? (
                        record1.map(
                          ({ folderName, size, createdAt, folder }, i) => (
                            <tr key={i}>
                              <td
                                style={{
                                  wordWrap: "break-word",
                                  whiteSpace: "normal",
                                  width: "100px",
                                }}
                                className="text-center"
                              >
                                {++i + (activePage1 - 1) * limit1}
                              </td>
                              <td>
                                <Link
                                  // to={`view/${folder}`}
                                  onClick={() => {
                                    // localStorage.setItem("folder", folderName)
                                    setFilePath(folderName);
                                    setCurrentPath(
                                      folderName
                                        .split("/")
                                        .filter((item) => item !== "")
                                    );
                                  }}
                                  style={{
                                    textDecoration: "none",
                                    color: "#0d6efd",
                                  }}
                                  className="m-0"
                                >
                                  {folder}
                                </Link>
                              </td>
                              <td>Folder</td>
                              <td>{dateFormat(createdAt)}</td>
                              <td>{size}</td>
                              {/*<td
                                style={{
                                  wordWrap: "break-word",
                                  whiteSpace: "normal",
                                  width: "150px",
                                }}
                              >
                                <div className="d-flex justify-content-center">
                                  <Link
                                    // to={`view/${folder}`}
                                    onClick={() => {
                                      // localStorage.setItem("folder", folderName)
                                      setFilePath(folderName);
                                      setCurrentPath(
                                        folderName
                                          .split("/")
                                          .filter((item) => item !== "")
                                      );
                                    }}
                                    className="m-0"
                                    type="acl"
                                    role={120115}
                                  >
                                    <IconButton
                                      aria-label="view"
                                      className="px-2 py-0"
                                    >
                                      <AutoAwesomeMotionIcon
                                        sx={{ color: "#4971B2" }}
                                      />
                                    </IconButton>
                                  </Link>
                                </div>
                              </td>*/}
                              {/*} <td
                                style={{
                                  wordWrap: "break-word",
                                  whiteSpace: "normal",
                                  width: "150px",
                                }}
                              >
                                <div className="d-flex justify-content-center">
                                  <Link
                                    //   to={`/course-management/billing-courses/update/${id}`}
                                    className="m-0"
                                    onClick={() => {
                                      setData1({
                                        ...data1,
                                        file: folder,
                                        oldFile: folder,
                                      });
                                      setEditModal1(true);
                                    }}
                                  >
                                    <IconButton
                                      aria-label="view"
                                      className="px-2 py-0"
                                    >
                                      <EditIcon sx={{ color: "#4971B2" }} />
                                    </IconButton>
                                  </Link>
                                </div>
                              </td>*/}
                            </tr>
                          )
                        )
                      ) : (
                        <NotFound cols={12} />
                      )}
                    </tbody>
                  </table>
                </div>
                {total1 >= 10 ? (
                  <div className="Pagination">
                    <Pagination
                      activePage={activePage1}
                      previousLabel={"previous"}
                      nextLabel={"next"}
                      itemsCountPerPage={limit1}
                      totalItemsCount={total1}
                      pageRangeDisplayed={5}
                      onChange={(page) => setActivePage1(page)}
                    />
                  </div>
                ) : null}
              </>
            ) : (
              <>
                <div className="search_wrap">
                  <div className="search_wrap">
                    <div className="SearchBox ">
                      {/* <div style={{ marginRight: "10px" }}>
                    <Input
                      className={"form-control"}
                      placeholder="Search Here"
                      value={search}
                      onChange={({ target }) => setSearch(target.value)}
                      type="text"
                    />
                  </div> */}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        {/* <Button
                        style={{ marginRight: "10px" }}
                        onClick={() => {
                          setUploadModal2(true);
                        }}
                      >
                        Upload Document
                      </Button> */}
                        {/* <Button
                      style={{ marginRight: "10px" }}
                      onClick={() => {
                        setAddModal(true);
                      }}
                    >
                      Create Folder
                    </Button> */}
                      </div>
                    </div>
                  </div>
                  {/* <h4 className="Title">
                  <Link
                    // to={-1}
                    onClick={() => setCurrentPath([])}
                  >
                    <i className="fa fa-arrow-left"></i>
                  </Link>
                  {currentPath[currentPath.length - 1]} Documents
                </h4> */}
                </div>
                {/* <hr className="border border-danger" /> */}
                {loader2}
                <div className="TableList overflow-auto table-responsive p-0">
                  <table className="position-relative">
                    <thead>
                      <tr>
                        <th
                          style={{
                            wordWrap: "break-word",
                            whiteSpace: "normal",
                            width: "100px",
                          }}
                        >
                          S.No
                        </th>
                        <th>Name</th>
                        <th>Type</th>
                        <th>Added On</th>
                        <th>Size</th>
                        <th
                          style={{
                            wordWrap: "break-word",
                            whiteSpace: "normal",
                            width: "100px",
                          }}
                        >
                          Action
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {record3 &&
                        record3.length > 0 &&
                        record3.map(
                          (
                            { fileName, filePath, size, createdAt, folder },
                            i
                          ) => (
                            <tr key={i}>
                              <td
                                style={{
                                  wordWrap: "break-word",
                                  whiteSpace: "normal",
                                  width: "100px",
                                }}
                                className="text-center"
                              >
                                {++i + (activePage1 - 1) * limit1}
                              </td>
                              <td>
                                <Link
                                  // to={`view/${folder}`}
                                  onClick={() => {
                                    setFilePath(filePath);
                                    setCurrentPath(
                                      filePath
                                        .split("/")
                                        .filter((item) => item !== "")
                                    );
                                  }}
                                  style={{
                                    textDecoration: "none",
                                    color: "#0d6efd",
                                  }}
                                  className="m-0"
                                >
                                  {fileName}
                                </Link>
                              </td>
                              <td>Folder</td>
                              <td>{dateFormat(createdAt)}</td>
                              <td>{size}</td>
                              {/*<td
                                style={{
                                  wordWrap: "break-word",
                                  whiteSpace: "normal",
                                  width: "150px",
                                }}
                              >
                                <div className="d-flex justify-content-center">
                                  <Link
                                    // to={`view/${folder}`}
                                    onClick={() => {
                                      // localStorage.setItem("folder", folderName)
                                      setFilePath(folderName);
                                      setCurrentPath(
                                        folderName
                                          .split("/")
                                          .filter((item) => item !== "")
                                      );
                                    }}
                                    className="m-0"
                                    type="acl"
                                    role={120115}
                                  >
                                    <IconButton
                                      aria-label="view"
                                      className="px-2 py-0"
                                    >
                                      <AutoAwesomeMotionIcon
                                        sx={{ color: "#4971B2" }}
                                      />
                                    </IconButton>
                                  </Link>
                                </div>
                              </td>*/}
                              <td
                                style={{
                                  wordWrap: "break-word",
                                  whiteSpace: "normal",
                                  width: "150px",
                                }}
                              >
                                <div className="d-flex justify-content-center">
                                  <Link
                                    //   to={`/course-management/billing-courses/update/${id}`}
                                    className="m-0"
                                    onClick={() => {
                                      setData2({
                                        ...data2,
                                        file: fileName,
                                        oldFile: fileName,
                                      });
                                      setEditModal2(true);
                                    }}
                                  >
                                    <IconButton
                                      aria-label="view"
                                      className="px-2 py-0"
                                    >
                                      <EditIcon sx={{ color: "#4971B2" }} />
                                    </IconButton>
                                  </Link>
                                  <IconButton
                                    aria-label="view"
                                    className="px-2 py-0"
                                    onClick={() => {
                                      setData2({
                                        ...data2,
                                        folderName: fileName,
                                      });
                                      setDeleteModal3(true);
                                    }}
                                  // type="acl"
                                  // role={400000}
                                  >
                                    <DeleteIcon sx={{ color: "#ff0000" }} />
                                  </IconButton>
                                </div>
                              </td>
                            </tr>
                          )
                        )}
                      {record2 &&
                        record2.length > 0 &&
                        record2.map(
                          ({ fileName, createdAt, size, fileURL }, i) => (
                            <tr key={i}>
                              <td
                                style={{
                                  wordWrap: "break-word",
                                  whiteSpace: "normal",
                                  width: "100px",
                                }}
                                className="text-center"
                              >
                                {++i +
                                  (activePage2 - 1) * limit2 +
                                  record3.length}
                              </td>
                              <td>{fileName}</td>
                              <td>{"file"}</td>
                              <td>{dateFormat(createdAt)}</td>
                              <td>{size}</td>
                              <td
                                style={{
                                  wordWrap: "break-word",
                                  whiteSpace: "normal",
                                  width: "150px",
                                }}
                              >
                                <div className="d-flex justify-content-center">
                                  <Link
                                    to={fileURL}
                                    target="_blank"
                                    className="m-0"
                                  >
                                    <IconButton
                                      aria-label="view"
                                      className="px-2 py-0"
                                    >
                                      <LaunchIcon sx={{ color: "#4971B2" }} />
                                    </IconButton>
                                  </Link>
                                  <Link
                                    //   to={`/course-management/billing-courses/update/${id}`}
                                    className="m-0"
                                    onClick={() => {
                                      setData2({
                                        ...data2,
                                        fileName: fileName,
                                        oldFileName: fileName,
                                      });
                                      setEditModal3(true);
                                    }}
                                  >
                                    <IconButton
                                      aria-label="view"
                                      className="px-2 py-0"
                                    >
                                      <EditIcon sx={{ color: "#4971B2" }} />
                                    </IconButton>
                                  </Link>
                                  <IconButton
                                    aria-label="view"
                                    className="px-2 py-0"
                                    onClick={() => {
                                      setData2({
                                        ...data2,
                                        fileName: fileName,
                                      });
                                      setDeleteModal2(true);
                                    }}
                                  // type="acl"
                                  // role={400000}
                                  >
                                    <DeleteIcon sx={{ color: "#ff0000" }} />
                                  </IconButton>
                                </div>
                              </td>
                            </tr>
                          )
                        )}
                      {record2.length <= 0 && record3.length <= 0 && (
                        <>
                          <NotFound cols={12} />
                        </>
                      )}
                    </tbody>
                  </table>
                </div>
                {total2 >= 10 ? (
                  <div className="Pagination">
                    <Pagination
                      activePage={activePage2}
                      previousLabel={"previous"}
                      nextLabel={"next"}
                      itemsCountPerPage={limit2}
                      totalItemsCount={total2}
                      pageRangeDisplayed={5}
                      onChange={(page) => setActivePage2(page)}
                    />
                  </div>
                ) : null}
              </>
            )}
          </div>
        </div>
      </div>

      {/* ********************************************* For First Record *********************************************************** */}
      {/* ***************************** Delete Modal ********************************** */}
      <ModalBox
        status={deleteModal1}
        onClose={() => setDeleteModal1(false)}
        title={"Delete Folder"}
        size={"md"}
        description={"Are you sure want to delete this folder"}
        customizedFooter={
          <div style={{ display: "flex", gap: "10px" }}>
            <Button
              onClick={() => setDeleteModal1(false)}
            // {...submitButtonElement1}
            >
              Cancel
            </Button>
            <Button onClick={handleDelete1} {...submitButtonElement2}>
              Delete
            </Button>
          </div>
        }
        custom={true}
      />
      {/* ***************************** Upload Document Modal ********************************** */}
      <ModalBox
        status={uploadModal1}
        onClose={() => setUploadModal1(false)}
        title={"Upload Document"}
        custom={true}
        size={"md"}
        description={
          <>
            <div className="row mt-1">
              <div className="col-12 col-sm-12 col-md-12 col-lg-11 col-xl-11 mx-auto">
                <div className="form-group row mt-1">
                  <div className="col-sm-12 col-form-label order-1 d-flex flex-column justify-content-end">
                    <div className="row">
                      <div className="col-sm-12 col-form-label">
                        <Input
                          type="file"
                          name="document"
                          placeholder="Select Folder/file"
                          className={`form-control`}
                          onChange={({ target }) =>
                            setData1({ ...data1, document: target.files[0] })
                          }
                          label={"Upload File"}
                          // accept="application/pdf"
                          // accept="image/*, .pdf, .txt"
                          // accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                          // error={errorField.file}
                          required
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        }
        customizedFooter={
          <div style={{ display: "flex", gap: "10px" }}>
            <Button
              onClick={() => setUploadModal1(false)}
            // {...submitButtonElement1}
            >
              Cancel
            </Button>
            <Button onClick={() => handleUpload1()} {...submitButtonElement1}>
              Upload
            </Button>
          </div>
        }
      />
      {/* ***************************** Add Modal ********************************** */}
      <ModalBox
        status={addModal1}
        onClose={() => setAddModal1(false)}
        title={"Add Folder"}
        size={"md"}
        custom={true}
        description={
          <>
            <div className="row mt-1">
              <div className="col-12 col-sm-12 col-md-12 col-lg-11 col-xl-11 mx-auto">
                <div className="form-group row mt-1">
                  <div className="col-sm-12 col-form-label order-1 d-flex flex-column justify-content-end">
                    <div className="row">
                      <div className="col-sm-12 col-form-label">
                        <Input
                          value={data1.file}
                          name="file"
                          onChange={(e) => {
                            const { name, value } = e.target;

                            setData1({
                              ...data1,
                              [name]: value,
                            });
                          }}
                          className={"form-control"}
                          label={"Folder Name"}
                          placeholder={"Enter Folder Name"}
                          // error={errorField.subjectname}
                          required // required
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        }
        customizedFooter={
          <div style={{ display: "flex", gap: "10px" }}>
            <Button
              onClick={() => setAddModal1(false)}
            // {...submitButtonElement2}
            >
              Cancel
            </Button>
            <Button onClick={() => handleAdd1()} {...submitButtonElement1}>
              Add
            </Button>
          </div>
        }
      />
      {/* ***************************** Update Modal ********************************** */}
      <ModalBox
        status={editModal1}
        onClose={() => setEditModal1(false)}
        title={"Rename Folder"}
        size={"md"}
        custom={true}
        description={
          <>
            <div className="row mt-1">
              <div className="col-12 col-sm-12 col-md-12 col-lg-11 col-xl-11 mx-auto">
                <div className="form-group row mt-1">
                  <div className="col-sm-12 col-form-label order-1 d-flex flex-column justify-content-end">
                    <div className="row">
                      <div className="col-sm-12 col-form-label">
                        <Input
                          value={data1.file}
                          name="file"
                          onChange={(e) => {
                            const { name, value } = e.target;

                            setData1({
                              ...data1,
                              [name]: value,
                            });
                          }}
                          className={"form-control"}
                          label={"Folder Name"}
                          placeholder={"Enter Folder Name"}
                        // error={errorField.subjectname}
                        // required
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        }
        customizedFooter={
          <div style={{ display: "flex", gap: "10px" }}>
            <Button
              onClick={() => setEditModal1(false)}
            // {...submitButtonElement1}
            >
              Cancel
            </Button>
            <Button onClick={() => handleUpdate1()} {...submitButtonElement1}>
              Update
            </Button>
          </div>
        }
      />

      {/* ************************************************** For Second Record ************************************************* */}
      {/* /* ***************************** Delete Folder Modal ********************************** */}
      <ModalBox
        status={deleteModal3}
        onClose={() => setDeleteModal3(false)}
        title={"Delete Folder"}
        size={"md"}
        description={"Are you sure want to delete this folder"}
        customizedFooter={
          <div style={{ display: "flex", gap: "10px" }}>
            <Button onClick={() => setDeleteModal3(false)}>Cancel</Button>
            <Button onClick={handleDelete3} {...submitButtonElement2}>
              Delete
            </Button>
          </div>
        }
        custom={true}
      />

      {/* /* ***************************** Delete File Modal ********************************** */}
      <ModalBox
        status={deleteModal2}
        onClose={() => setDeleteModal2(false)}
        title={"Delete File"}
        size={"md"}
        description={"Are you sure want to delete this file"}
        customizedFooter={
          <div style={{ display: "flex", gap: "10px" }}>
            <Button onClick={() => setDeleteModal2(false)}>Cancel</Button>
            <Button onClick={handleDelete2} {...submitButtonElement2}>
              Delete
            </Button>
          </div>
        }
        custom={true}
      />
      {/* ***************************** Upload Document Modal ********************************** */}
      <ModalBox
        status={uploadModal2}
        onClose={() => setUploadModal2(false)}
        title={"Upload Document"}
        custom={true}
        size={"md"}
        description={
          <>
            <div className="row mt-1">
              <div className="col-12 col-sm-12 col-md-12 col-lg-11 col-xl-11 mx-auto">
                <div className="form-group row mt-1">
                  <div className="col-sm-12 col-form-label order-1 d-flex flex-column justify-content-end">
                    <div className="row">
                      <div className="col-sm-12 col-form-label">
                        <Input
                          type="file"
                          name="document"
                          placeholder="Select file"
                          className={`form-control`}
                          onChange={({ target }) =>
                            setData2({ ...data2, document: target.files[0] })
                          }
                          label={"Upload File"}
                          onFocus={() => setIsFileInputFocused(true)}
                          onBlur={() => setIsFileInputFocused(false)}
                          accept="application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation, text/plain, text/csv, text/markdown, application/json, application/xml, image/png, image/jpeg, image/gif, image/bmp, image/svg+xml, image/webp, audio/mpeg, audio/wav, audio/ogg, video/mp4, video/webm, video/ogg, application/zip, application/x-rar-compressed, application/x-7z-compressed, application/x-tar, application/gzip, text/javascript, application/x-python-code, application/x-java-source, text/html, text/css"
                          // accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                          error={errorField2.document}
                          required
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        }
        customizedFooter={
          <div style={{ display: "flex", gap: "10px" }}>
            <Button
              onClick={() => {
                setUploadModal2(false);
                setData2({});
                setErrorField2({});
              }}
            // {...submitButtonElement2}
            >
              Cancel
            </Button>
            <Button onClick={handleUpload2} {...submitButtonElement2}>
              Upload
            </Button>
          </div>
        }
      />
      {/* ***************************** Add Modal ********************************** */}
      <ModalBox
        status={addModal2}
        onClose={() => setAddModal2(false)}
        title={"Add Folder"}
        size={"md"}
        custom={true}
        description={
          <>
            <div className="row mt-1">
              <div className="col-12 col-sm-12 col-md-12 col-lg-11 col-xl-11 mx-auto">
                <div className="form-group row mt-1">
                  <div className="col-sm-12 col-form-label order-1 d-flex flex-column justify-content-end">
                    <div className="row">
                      <div className="col-sm-12 col-form-label">
                        <Input
                          value={data2.file}
                          name="file"
                          onChange={(e) => {
                            const { name, value } = e.target;

                            setData2({
                              ...data2,
                              [name]: value,
                            });
                          }}
                          className={"form-control"}
                          label={"Folder Name"}
                          placeholder={"Enter Folder Name"}
                          error={errorField2.file}
                          required // required
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        }
        customizedFooter={
          <div style={{ display: "flex", gap: "10px" }}>
            <Button
              onClick={() => {
                setAddModal2(false);
                setData2({});
                setErrorField2({});
              }}
            // {...submitButtonElement2}
            >
              Cancel
            </Button>
            <Button onClick={handleAdd2} {...submitButtonElement1}>
              Add
            </Button>
          </div>
        }
      />
      {/* ***************************** Update Modal ********************************** */}
      <ModalBox
        status={editModal2}
        onClose={() => setEditModal2(false)}
        title={"Rename Folder"}
        size={"md"}
        custom={true}
        description={
          <>
            <div className="row mt-1">
              <div className="col-12 col-sm-12 col-md-12 col-lg-11 col-xl-11 mx-auto">
                <div className="form-group row mt-1">
                  <div className="col-sm-12 col-form-label order-1 d-flex flex-column justify-content-end">
                    <div className="row">
                      <div className="col-sm-12 col-form-label">
                        <Input
                          value={data2.file}
                          name="file"
                          onChange={(e) => {
                            const { name, value } = e.target;

                            setData2({
                              ...data2,
                              [name]: value,
                            });
                          }}
                          className={"form-control"}
                          label={"Folder Name"}
                          placeholder={"Enter Folder Name"}
                          error={errorField2.file}
                        // required
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        }
        customizedFooter={
          <div style={{ display: "flex", gap: "10px" }}>
            <Button
              onClick={() => {
                setEditModal2(false);
                setData2({});
                setErrorField2({});
              }}
            // {...submitButtonElement2}
            >
              Cancel
            </Button>
            <Button onClick={handleUpdate2} {...submitButtonElement2}>
              Update
            </Button>
          </div>
        }
      />

      <ModalBox
        status={editModal3}
        onClose={() => setEditModal3(false)}
        title={"Rename File"}
        size={"md"}
        custom={true}
        description={
          <>
            <div className="row mt-1">
              <div className="col-12 col-sm-12 col-md-12 col-lg-11 col-xl-11 mx-auto">
                <div className="form-group row mt-1">
                  <div className="col-sm-12 col-form-label order-1 d-flex flex-column justify-content-end">
                    <div className="row">
                      <div className="col-sm-12 col-form-label">
                        <Input
                          value={data2.fileName}
                          name="fileName"
                          onChange={(e) => {
                            const { name, value } = e.target;

                            setData2({
                              ...data2,
                              [name]: value,
                            });
                          }}
                          className={"form-control"}
                          label={"File Name"}
                          placeholder={"Enter File Name"}
                          error={errorField2.fileName}
                          required
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        }
        customizedFooter={
          <div style={{ display: "flex", gap: "10px" }}>
            <Button
              onClick={() => {
                setEditModal3(false);
                setData2({});
                setErrorField2({});
              }}
            // {...submitButtonElement2}
            >
              Cancel
            </Button>
            <Button onClick={handleUpdate3} {...submitButtonElement2}>
              Update
            </Button>
          </div>
        }
      />
    </>
  );
}
